export enum AutoDeskIntegrationTypeEnum {
    LATEST_IMAGE = 'LATEST_IMAGE',
    DAY_IMAGES = 'DAY_IMAGES',
    ALL_IMAGES = 'ALL_IMAGES',
}

export enum AutodeskImageFrequencyEnum {
    MIN_1 = 1,
    MIN_5 = 5,
    MIN_10 = 10,
    MIN_15 = 15,
    MIN_30 = 30,
    MIN_60 = 60,
    MIN_120 = 120,
}
